import React from "react"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import Flex from "@irati/ui/src/Flex"
import {H6} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"
import {usePromotionStatus} from "@irati/promotions/hooks"
import {PromotionType} from "@irati/types"
import IntlMarkdown from "../../styled/IntlMarkdown"
import {Container, PresentsImg, LimitedDeal} from "./styled"
import useAuth from "@irati/auth/helpers/auth/useAuth"

const ChristmasBanner = injectIntl(function ChristmasComp({formatMessage}) {
  const {data} = usePromotionStatus({type: PromotionType.FlexiRewardTopupChristmas23Campaign})
  const auth = useAuth()
  const canTopUpRewardPoints = auth.productPermissions?.wallet?.flexiRewards?.canTopUpRewardPoints
  if (!data?.enabled) return null

  return (
    <Container as="article">
      <Flex direction="column" gap={2} flex="10 1 350px">
        <LimitedDeal>
          <H6 as="p">
            <FormattedMessage id="wallet.reward.admin.christmas.banner.dealEndDate" />
          </H6>
        </LimitedDeal>

        <IntlMarkdown white bullets id="wallet.reward.admin.christmas.banner.info" />

        <Flex alignItems="center" gap={2} marginTop={1}>
          {canTopUpRewardPoints && (
            <ButtonRouterLink
              primary
              inverted
              to="/flexi-checkout/top-up"
              onClick={() => tracking.clickChristmasBanner("rp_wallet_christmasbanner", {type: "buy_points"})}>
              <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.buyPoints" />
            </ButtonRouterLink>
          )}
          <ButtonLink
            cta
            inverted
            href={formatMessage({id: "wallet.reward.admin.christmas.banner.articleLink"})}
            target="_blank"
            onClick={() => tracking.clickChristmasBanner("rp_wallet_christmasbanner", {type: "learn_more"})}>
            <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.learnMore" />
          </ButtonLink>
        </Flex>
      </Flex>

      <Flex direction="column" alignItems="center" justifyContent="center" flex="1">
        <PresentsImg />
      </Flex>
    </Container>
  )
})

export default ChristmasBanner
